exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*GROUPS*/\r\n.grp-name {\r\n  width: 100%;\r\n  font-size: larger;\r\n}\r\n\r\n.grp-name:hover {\r\n  background-color: #f7f7f7;\r\n  /*cursor: pointer;*/\r\n}\r\n\r\n/*POSITIONS*/\r\n.grp-pos {\r\n  width: 100%;\r\n  padding-left: 45px;\r\n}\r\n\r\n.grp-pos:hover {\r\n  background-color: #f7f7f7;\r\n  cursor: pointer;\r\n}\r\n\r\n/*BLOCK*/\r\n.filter-list {\r\n  background-color: white;\r\n  border: 1px solid #d0d0d0;\r\n  border-radius: 5px;\r\n  /* height: 320px; */\r\n  overflow-y: auto;\r\n  width: -webkit-max-content;\r\n  width: -moz-max-content;\r\n  width: max-content;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.full-width {\r\n  width: 100%;\r\n}\r\n\r\n.selected-division {\r\n  background-color: #e6e6e6;\r\n}\r\n\r\ntextarea::-webkit-input-placeholder {\r\n  color: #a15d5c;\r\n}\r\n\r\ntextarea:-ms-input-placeholder {\r\n  color: #a15d5c;\r\n}\r\n\r\ntextarea::placeholder {\r\n  color: #a15d5c;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/new2/internal-frontend/src/app/content-page/common/suggestion-lists/components/view-suggestion-list/implementation-members/implementation-members.component.css
// module id = ../../../../../src/app/content-page/common/suggestion-lists/components/view-suggestion-list/implementation-members/implementation-members.component.css
// module chunks = main